import React, { useCallback } from 'react';
import styles from './SubtitlesList.module.scss';
import { gql, useMutation } from '@apollo/client';
import { VideoSubtitle } from '@types';
import TrashIcon from '@assets/icons/trash_circle.svg?react';
import { logger } from '../../utils/logger';

type Props = {
  id?: string;
  playbackId?: string;
  subtitles?: any[];
};

export const subtitlesQuery = gql`
    query Subtitles($assetId: String, $playbackId: String) {
        videoSubtitles(assetId: $assetId, playbackId: $playbackId) {
            id
            languageCode
            name
        }
    }
`;

export type SubtitlesResponse = {
  videoSubtitles: VideoSubtitle[]
};

const deleteMutation = gql`
    mutation DeleteTrack($trackId: ID!, $assetId: ID, $playbackId: ID) {
        deleteVideoSubtitle(trackId: $trackId, playbackId: $playbackId, assetId: $assetId)
    }
`;

type DeleteResponse = {
  deleteVideoSubtitle: string;
}

function SubtitlesList(props: Props) {
  const { id, playbackId, subtitles } = props;

  // const [getSubtitles, { data }] = useVideoSubtitlesLazyQuery({ fetchPolicy: 'network-only' })
  const [deleteSubtitle] = useMutation<DeleteResponse>(deleteMutation, {
    onError(e) {
      logger.debug(`[Error while remove subtitle]`, e);
      alert(e.message);
    },
    update(cache, res) {
      const deletedId = res.data?.deleteVideoSubtitle;
      if (deletedId) {
        const subtitlesResponse = cache.readQuery<SubtitlesResponse>({
          query: subtitlesQuery, variables: {
            assetId: id,
            playbackId,
          }
        });

        cache.writeQuery({
          query: subtitlesQuery, variables: {
            assetId: id,
            playbackId,
          },
          data: {
            videoSubtitles: [...subtitlesResponse?.videoSubtitles?.filter(s => s.id !== deletedId) || []]
          }
        });
      }
    }
  });

  const removeSubtitle = useCallback((subtitle: VideoSubtitle) => () => {
    if (window.confirm('Are you sure you want to delete subtitle?')) {
      deleteSubtitle({
        variables: {
          assetId: id,
          playbackId,
          trackId: subtitle.id
        }
      });
    }
  }, [deleteSubtitle, id, playbackId])

  if (!id && !playbackId) return null;
  if (!subtitles || subtitles.length === 0) return null;
  return (
    <div className={styles.wrapper}>
      {subtitles?.map((sub: VideoSubtitle, index) => {
        return (
          <div className={styles.row} key={sub?.id ?? index}>
            <div className={styles.code}>
              {sub?.languageCode}
            </div>
            <div className={styles.name}>{sub?.name}</div>
            <div className={styles.actions}>
              <TrashIcon className={styles.icon} onClick={removeSubtitle(sub as VideoSubtitle)}/>
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default SubtitlesList;
